import { __assign } from "tslib";
import React from 'react';
import TrilogyModal from '@trilogy-ds/react/lib/components/modal/Modal';
var Modal = React.forwardRef(function (props, ref) {
    var accessibilityLabel = function (props) {
        if (props.accessibilityLabel) {
            return props.accessibilityLabel;
        }
        return 'Fermer';
    };
    var modalProps = __assign({ accessibilityLabel: accessibilityLabel(props) }, props);
    return (React.createElement(TrilogyModal, __assign({}, modalProps, { ref: ref }), props.children));
});
export default Modal;
//# sourceMappingURL=Modal.js.map